{
  "brand": {
    "name": "Restomator"
  },
  "header": {
    "title": {
      "signIn": "Sign in to {{target}}",
      "signUp": "Create an account for {{target}}"
    },
    "subtitle": {
      "signInWithTenant": "Welcome back! Sign in to manage {{target}}.",
      "signInDefault": "Welcome back! Sign in to Restomator to continue.",
      "signUpWithTenant": "Create a new account to manage {{target}}.",
      "signUpDefault": "Create a new Restomator account to continue."
    }
  },
  "status": {
    "loadingTenant": "Loading tenant information…"
  },
  "form": {
    "email": {
      "label": "Email address",
      "errors": {
        "required": "Please enter your email address.",
        "email": "This email address is invalid."
      }
    },
    "password": {
      "label": "Password",
      "errors": {
        "required": "Please enter your password.",
        "minLength": "Password must be at least 8 characters long."
      }
    },
    "confirmPassword": {
      "label": "Confirm password",
      "errors": {
        "required": "Please confirm your password.",
        "mismatch": "Passwords do not match."
      }
    }
  },
  "actions": {
    "submit": {
      "signIn": "Sign in",
      "signUp": "Create account"
    },
    "modeSwitch": {
      "signIn": "Sign in now",
      "signUp": "Create account",
      "prefixSignIn": "Don't have an account?",
      "prefixSignUp": "Already registered?"
    },
    "providers": {
      "sectionSignIn": "or continue with",
      "sectionSignUp": "or sign up with"
    }
  },
  "providers": {
    "google": "Google",
    "facebook": "Facebook",
    "apple": "Apple"
  },
  "footer": {
    "terms": "By signing in you accept Restomator's Terms of Service and Privacy Policy."
  },
  "errors": {
    "firebase": {
      "invalidEmail": "Please check your email address.",
      "userDisabled": "This account has been disabled. Please contact support.",
      "invalidCredentials": "Email or password is incorrect.",
      "emailAlreadyInUse": "An account with this email already exists. Please sign in.",
      "weakPassword": "The password is too weak. Choose a stronger password with at least 8 characters.",
      "popupClosed": "Sign-in was cancelled.",
      "popupCancelled": "A sign-in is already in progress. Please close existing pop-ups.",
      "popupBlocked": "The pop-up was blocked. Please allow pop-ups for this site.",
      "genericSignIn": "Sign-in failed. Please try again.",
      "genericSignUp": "Registration failed. Please try again."
    }
  }
}
